"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function linkIsInternal(linkElement) {
  return linkElement.substring(0, 1) === '/';
}
function linkIsEmail(linkElement) {
  return /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/.test(linkElement);
}
var RouteLinks = function RouteLinks(_ref) {
  var title = _ref.title,
    to = _ref.to,
    children = _ref.children;
  return linkIsEmail(to) ? /*#__PURE__*/_react.default.createElement("a", {
    href: "mailto:".concat(to)
  }, children) : linkIsInternal(to) ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.HashRouter, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: to,
    title: title
  }, children)) : /*#__PURE__*/_react.default.createElement("a", {
    href: to,
    target: "external-url"
  }, children);
};
RouteLinks.propTypes = {
  to: _propTypes.default.string.isRequired
};
var _default = RouteLinks;
exports.default = _default;